import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

export const createTitleResolver = (
  translationKey: string,
  params?: Record<string, string | number | boolean>
): ResolveFn<string> => {
  return () => {
    const translateService = inject(TranslateService);

    return translateService.instant(translationKey, params);
  };
};
